import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a contemporary chandelier from the 2.6 m ceiling: a central
// stem and six short matte-black arms, each carrying a glow-tone bulb sphere.
const BLACK = "#2e2e30";
const BRASS = "#c9a35a";
const GLOW = "#f5e9c8";

const CEILING = 2.6;
const HUB_Y = 2.02;
const ARM_LEN = 0.3;
const ARM_R = 0.15 + ARM_LEN / 2; // arm centre radius from the stem

export const chandelier = defineModel({
  id: "chandelier",
  batchId: "modern",
  name: "Chandelier",
  tags: ["modern", "interior", "fixture", "lighting", "ceiling"],
  summary: "A modern six-arm chandelier with glow-tone bulb spheres.",
  tiles: { w: 1, h: 1 },
  footprint: 0.9,
  parts(): Part[] {
    const parts: Part[] = [
      // Ceiling rose.
      { geometry: new THREE.CylinderGeometry(0.06, 0.06, 0.035, 12), color: BLACK,
        position: [0, CEILING - 0.0175, 0] },
      // Central stem.
      { geometry: new THREE.CylinderGeometry(0.012, 0.012, CEILING - HUB_Y, 8), color: BLACK,
        position: [0, (CEILING + HUB_Y) / 2, 0] },
      // Hub the arms radiate from.
      { geometry: new THREE.CylinderGeometry(0.06, 0.06, 0.07, 12), color: BRASS,
        position: [0, HUB_Y, 0] },
    ];
    for (let i = 0; i < 6; i++) {
      const ang = (i * Math.PI) / 3;
      const dx = Math.cos(ang);
      const dz = Math.sin(ang);
      // Short flat arm.
      parts.push({
        geometry: new THREE.BoxGeometry(ARM_LEN, 0.025, 0.04), color: BLACK,
        position: [dx * ARM_R, HUB_Y, dz * ARM_R], rotation: [0, -ang, 0],
      });
      // Bulb sphere at the arm tip.
      parts.push({
        geometry: new THREE.SphereGeometry(0.05, 10, 8), color: GLOW,
        position: [dx * (ARM_R + ARM_LEN / 2), HUB_Y + 0.055, dz * (ARM_R + ARM_LEN / 2)],
      });
    }
    return parts;
  },
  animations: [],
});
